module.exports = __webpack_public_path__ + "img/lanmu.8674bf59.svg";